import { ChangeDetectionStrategy, Component, forwardRef, Input, Type, ChangeDetectorRef, Output, EventEmitter } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [{
		provide: NG_VALUE_ACCESSOR,
		multi: true,
		useExisting: forwardRef((): Type<TabComponent> => TabComponent)
	}],
	selector: "app-tab",
	styleUrls: ["./tab.component.scss"],
	template: `
	<ng-content></ng-content>
	<app-tab-item
		*ngFor="let tab of tabs; let i = index"
		[isActive]="!newStyle && tab[1] === value"
		[isChecked]="newStyle && tab[1] === value"
		[newStyle]="newStyle"
		[isDisabled]="isDisabled"
		(click)="setTab(tab[1])">
		{{ tab[0] }}
	</app-tab-item>
	`
})
export class TabComponent implements ControlValueAccessor {
	@Input()
	public tabs: [string, any][] = [];
	@Input() newStyle: boolean = false;
	@Input() isDisabled: boolean = false;
	@Output() public valueChange: EventEmitter<any> = new EventEmitter<any>();
	public value: any;

	private onChange?: (...args: any[]) => void;
	private onTouched?: (...args: any[]) => void;

	constructor(private readonly changeDetectorRef: ChangeDetectorRef) { }

	public writeValue(value: any): void {
		this.value = value ? value : this.tabs[0] && this.tabs[0][1];

		if (this.onChange && typeof this.onChange === "function")
			this.onChange(this.value);
		if (this.onTouched && typeof this.onTouched === "function")
			this.onTouched(this.value);
		this.changeDetectorRef.detectChanges();
	}

	public setTab(value: any): void {
		this.writeValue(value);
		this.valueChange.emit(value);
	}

	public registerOnChange(fn: any): void {
		this.onChange = fn;
	}

	public registerOnTouched(fn: any): void {
		this.onTouched = fn;
	}
}
